/* Zeke Squad: ad shirt first (rebuilt Sep 27, 2026)
   Link format: /collections/<collection-handle>?first=<product-handle>
   Shows that shirt as the first card in the collection grid, using the real
   product card (correct quick add, swatches, price, reviews), removes the
   duplicate further down, and jumps the page to the grid. */
(function () {
  var params = new URLSearchParams(window.location.search);
  var raw = (params.get('first') || params.get('featured') || '').trim();
  if (!raw) return;
  if (window.location.pathname.indexOf('/collections/') === -1) return;

  var handle = raw;
  if (/^https?:/i.test(raw) || raw.indexOf('/products/') !== -1) {
    try {
      var m0 = new URL(raw, window.location.origin).pathname.match(/\/products\/([^\/?#]+)/);
      handle = m0 ? m0[1] : '';
    } catch (e) { return; }
  }
  try { handle = decodeURIComponent(handle); } catch (e) {}
  handle = handle.toLowerCase();
  if (!handle || /[\/?#\s]/.test(handle)) return;

  var page = parseInt(params.get('page') || '1', 10) || 1;
  var variantId = params.get('variant');

  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  function removeDupes(grid) {
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      if (!li.classList.contains('zs-first-item') && handleOf(li) === handle) li.remove();
    });
  }

  function watch(grid) {
    if (!window.MutationObserver) return;
    new MutationObserver(function () { removeDupes(grid); }).observe(grid, { childList: true });
  }

  function matchLook(li, grid) {
    var sample = grid.querySelector('li.grid__item:not(.zs-first-item) .card');
    if (!sample) return;
    var card = li.querySelector('.card');
    var inner = li.querySelector('.card__inner');
    var sInner = sample.querySelector('.card__inner');
    if (card && sample.getAttribute('style')) card.setAttribute('style', sample.getAttribute('style'));
    if (inner && sInner && sInner.getAttribute('style')) inner.setAttribute('style', sInner.getAttribute('style'));
    var sampleImgCount = sample.querySelectorAll('.card__media img').length;
    var imgs = li.querySelectorAll('.card__media img');
    if (sampleImgCount < 2) {
      for (var i = 1; i < imgs.length; i++) imgs[i].remove();
    }
  }

  function jumpToGrid(grid) {
    if (window.scrollY > 50) return;
    var target = document.getElementById('ProductGridContainer') || grid;
    var top = target.getBoundingClientRect().top + window.scrollY;
    if (top < window.innerHeight * 0.6) return;
    var header = document.querySelector('sticky-header, .header-wrapper, .section-header');
    var offset = header ? header.offsetHeight : 0;
    window.scrollTo({ top: Math.max(0, top - offset - 10), behavior: 'auto' });
  }

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (page > 1) { removeDupes(grid); watch(grid); return; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=ad-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var li = tmp.querySelector('li.zs-first-item');
        if (!li) return;
        if (variantId && /^\d+$/.test(variantId)) {
          li.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            var href = a.getAttribute('href') || '';
            a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId);
          });
        }
        matchLook(li, grid);
        removeDupes(grid);
        grid.insertBefore(li, grid.firstElementChild);
        watch(grid);
        jumpToGrid(grid);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
